import CabinetIconPreview from './CabinetIconPreview';

export default CabinetIconPreview;
